import type { schemaType as closedDatesSchematype } from '~~/shared/api/rurality/v3/cottages/detail/closed-dates/schema'
import type { disableDatesInterface } from '~~/modules/design-system/components/t-date-input/index.vue'

export const useToTDateInput = () => {
  const fromClosedDates = (
    data: closedDatesSchematype,
  ): disableDatesInterface[] => {
    const disableDates: disableDatesInterface[] = []
    data.closedDates.forEach((date: string) => {
      disableDates.push({
        start: date,
        end: date,
      })
    })

    return disableDates
  }

  return { fromClosedDates }
}
